import { render } from "./WarrantyClaimDetails.vue?vue&type=template&id=e9679b7c"
import script from "./WarrantyClaimDetails.vue?vue&type=script&lang=js"
export * from "./WarrantyClaimDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__